import {Pipe, PipeTransform, inject} from '@angular/core';
import {FormatService} from "../../services/format.service";
import {isNumeric} from "../utils/epic.utils";

@Pipe({name: 'fileSize', pure: true, standalone: true})
export class FileSizePipe implements PipeTransform {
  private readonly format = inject(FormatService);

  transform(bytes: number | undefined, decimals?: number | undefined): string {
    if (bytes === undefined || !isNumeric(bytes)) {
      return 'Invalid size';
    }
    return this.format.formatBytes(bytes, decimals);
  }
}
